import React from "react";
import "./workexperience.css";

const WorkExperience = () => {
  return (
    <section id="wexperience">
      {/* <h5>What Works Experience I Have</h5> */}
      <h2>Works Experience</h2>

      <div className="container wexperience__container">
        {/* <div className="wexperience__operatorgdc">
          <h3>PT Astra Honda Motor • Production Operator</h3>
          <h5>Casting Wheel Die Casting • Jul 2018 - Apr 2020</h5>
        </div>
        <div className="wexperience__operatorhpdc">
          <h3>PT Astra Honda Motor • Production Operator</h3>
          <h5>High Pressure Die Casting • Jul 2020 - Jul 2021</h5>
        </div>
        <div className="wexperience__marketing">
          <h3>CV Dua Mitratama • Sales & Marketing</h3>
          <h5>Marketing • Sep 2021 - Sep 2024</h5>
        </div> */}
        <div className="wexperience__intern">
          <h3>CV Dua Mitratama • Frontend Web Developer Intern</h3>
          <h5>Jul 2022 - Dec 2022</h5>
        </div>
        <div className="wexperience__intern">
          <h3>Roote Trails • Frontend Developer Intern</h3>
          <h5>Feb 2025 - May 2025</h5>
        </div>
        <div className="wexperience__wiratek">
          <h3>PT Wiratek Solusi Asia • Software Engineer</h3>
          <h5>Jun 2025 - Present</h5>
        </div>
      </div>
    </section>
  );
};

export default WorkExperience;
